import { tap } from 'lodash/fp';
import * as designBuilderApi from '../api/designBuilder';
import estimateLoaded from './estimateLoaded';
import itemCopied from './itemCopied';
import loaded from './loaded';
import loading from './loading';
import globalError from './globalError';
import uniqueNewName from '../helpers/uniqueNewName';
import smoothScroll from '../helpers/smoothScroll';
import getElementHeight from '../helpers/getElementHeight';

const copyItem = itemId => (dispatch, getState) => {
  dispatch(loading());
  const { uiState, entities } = getState().estimateBuilder;
  const { selectedEstimate } = uiState;
  const { containers, items } = entities;
  const { allIds, byId } = containers;

  const containerId = allIds.find(givenId => byId[givenId].items.indexOf(itemId) !== -1);
  const existingNames = byId[containerId].items.map(i => items.byId[i].label);

  const newName = uniqueNewName('Window {{num}}', existingNames);

  return designBuilderApi
    .copyItem(selectedEstimate, itemId, newName)
    .then((response) => {
      dispatch(estimateLoaded(response.data));
      dispatch(itemCopied(containerId));
      smoothScroll(`#scrollbottom-${containerId}`, getElementHeight('.itemCard'));
    })
    .then(tap(() => dispatch(loaded())))
    .catch(err => dispatch(globalError({ err })));
};

export default copyItem;
